
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.tooltip {
  position: relative;
  z-index: unset;
  display: inline-flex;
  overflow: hidden;
  vertical-align: top;
  padding-right: 2px;
  font-style: normal;
}
.tooltip.tooltip-active {
  overflow: visible;
}
.tooltip.tooltip-active .tooltip-container {
  opacity: 1;
  transition: opacity 0.3s;
}
.tooltip .tooltip-container {
  box-sizing: border-box;
  max-width: 100vw;
  max-height: 100vh;
  overflow: auto;
  opacity: 0;
  position: absolute;
  z-index: 9999;
  background: var(--slh-color-neutral-shade-80, #4E5E7E);
  padding: 2px 8px;
  border-radius: 4px;
  top: unset;
  left: unset;
  right: unset;
  bottom: unset;
}
.tooltip .tooltip-container.tooltip-container-bottom {
  top: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.tooltip .tooltip-container.tooltip-container-bottom.tooltip-container-align-start {
  left: unset;
  transform: unset;
}
.tooltip .tooltip-container.tooltip-container-bottom.tooltip-container-align-end {
  left: unset;
  transform: unset;
  right: 2px;
}
.tooltip .tooltip-container.tooltip-container-top {
  bottom: calc(100% + 4px);
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}
.tooltip .tooltip-container.tooltip-container-top.tooltip-container-align-start {
  left: unset;
  transform: unset;
}
.tooltip .tooltip-container.tooltip-container-top.tooltip-container-align-end {
  left: unset;
  transform: unset;
  right: 2px;
}
.tooltip .tooltip-container.tooltip-container-left {
  right: calc(100% + 4px);
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}
.tooltip .tooltip-container.tooltip-container-left.tooltip-container-align-start {
  top: unset;
  transform: unset;
}
.tooltip .tooltip-container.tooltip-container-left.tooltip-container-align-end {
  bottom: 0;
  top: unset;
  transform: unset;
}
.tooltip .tooltip-container.tooltip-container-right {
  left: calc(100% + 4px);
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}
.tooltip .tooltip-container.tooltip-container-right.tooltip-container-align-start {
  top: unset;
  transform: unset;
}
.tooltip .tooltip-container.tooltip-container-right.tooltip-container-align-end {
  bottom: 0;
  top: unset;
  transform: unset;
}
.tooltip .tooltip-container .tooltip-text {
  font-size: var(--slh-base-xxs-font-size, 12px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  font-family: var(--slh-default-font-family, "Open Sans");
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
}
.tooltip .tooltip-trigger {
  display: inline-block;
  position: relative;
  z-index: 1;
}
.tooltip ::slotted(.icon-wrapper) {
  fill: currentColor;
}

:host {
  outline: none;
}
:host ::slotted(.icon-wrapper) {
  fill: currentColor;
}
:host slot[name=content]::slotted(*) {
  margin: 0;
}
`;
